import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { interval, Observable, Subject } from 'rxjs';
import { LoginService } from './login.service';

@Injectable({
    providedIn: 'root'
})
export class SessionManagementService {
    private sessionExpired = new Subject<boolean>();

    constructor(private router: Router, private loginService: LoginService) {
        
        // Check every minute for session expiration
        interval(60000).subscribe(() => {
            if (this.checkLoginExpiration()) {
                this.handleSessionExpiration();
            }
        });
    }

    checkLoginExpiration(): boolean {
        let sessionExpired = true;
        const storedTimestamp = sessionStorage.getItem('loginTimestamp');
        if (storedTimestamp){
            const loginTime = new Date(storedTimestamp);
            const currentTime = new Date();
            const fourHoursInMilliseconds = 4 * 60 * 60 * 1000;
            sessionExpired = (currentTime.getTime() - loginTime.getTime()) > fourHoursInMilliseconds;
        };
        return sessionExpired;
    }

    handleSessionExpiration(): void {
        const loginUser = sessionStorage.getItem('loginUser');
        let userId = 0;
        let refNum = '';

        try {
            if (loginUser) {
                const parsedUser = JSON.parse(loginUser);
                userId = parsedUser?.userId || 0;
                refNum = parsedUser?.refNum || '';
            }
        } catch (error) {
            // Handle error silently
        }
        this.loginService.logOutUser(userId, true, refNum).subscribe({
            error: () => {
                // Handle error silently
            }
        });
        sessionStorage.clear();
        this.sessionExpired.next(true);
        this.router.navigate(['/login']);
    }

    getSessionExpired(): Observable<boolean> {
        return this.sessionExpired.asObservable();
    }
}